module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kansai-4-ee60e1c40aac57e6c70f095bb1820510.png";